'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.change = change;

var _Images = require('helpers/Images');

var _Images2 = _interopRequireDefault(_Images);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* ======================================
=            Payment Reducer            =
========================================= */
var CHANGE = 'lookme/payment/CHANGE';

var initialState = {
  dataHistory: [{
    img: _Images2.default.payment.atm,
    amount: '50000',
    time: '00:00 - DD/MM/YYYY'
  }, {
    img: _Images2.default.payment.atm,
    amount: '50000',
    time: '00:00 - DD/MM/YYYY'
  }, {
    img: _Images2.default.payment.atm,
    amount: '50000',
    time: '00:00 - DD/MM/YYYY'
  }, {
    img: _Images2.default.payment.atm,
    amount: '50000',
    time: '00:00 - DD/MM/YYYY'
  }, {
    img: _Images2.default.payment.atm,
    amount: '50000',
    time: '00:00 - DD/MM/YYYY'
  }]
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case CHANGE:
      return (0, _extends3.default)({}, state);
    default:
      return state;
  }
}

/* ----------  actions  ---------- */

function change(value) {
  return {
    type: CHANGE,
    value: value
  };
}
/* =====  End of Payment Reducer  ====== */


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/payment.js
// module id = 1703
// module chunks = 0